export default function getResource(label, vars = []) {
    const resources = {
        relatedSearchesTitle: 'Recherches connexes',
        searchForTerm: `Rechercher ${vars[0]}`,
        loadingRelatedSearches: 'Loading related searches'
    };

    return resources[label];
}
